import React, { PureComponent } from 'react';
import Select from '@mui/material/Select';
import { Drawer, Divider, Typography, IconButton, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import LoadingButton from '../utils/LoadingButton';
import CloseIcon from '@mui/icons-material/Close';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { StatisticsGrouped } from '../map/SchedulingMap';

const groupStatisticsByOptions = [
  { value: '', label: '-' },
  { value: 'Test Pckg - Final', label: 'Test Package' },
  { value: 'Grower', label: 'Grower' },
  { value: 'Client', label: 'Client' },
] as const;

export type GroupStatisticsBy = (typeof groupStatisticsByOptions)[number]['value'];

interface SideBarInfoProps {
  statisticsGrouped: StatisticsGrouped;
  totalFields: number;
  totalAcres: number;
  totalOpsAcres: number;
  totalSamples: number;
  averageAcres: number;
  averageSamples: number;
  jobLinks: {
    name: string;
    link: string;
  }[];
  onClose: () => void;
  setWeatherDays: (days: number) => Promise<void>;
  onGroupStatisticsByChange: (newGroupBy: GroupStatisticsBy) => void;
}

interface SideBarInfoState {
  weatherDates: string;
  groupStatisticsBy: GroupStatisticsBy;
}

export default class SideBarInfo extends PureComponent<SideBarInfoProps, SideBarInfoState> {
  constructor(props: SideBarInfoProps) {
    super(props);

    this.state = {
      weatherDates: '',
      groupStatisticsBy: 'Test Pckg - Final',
    };

    this.setWeatherDays = this.setWeatherDays.bind(this);
  }

  async setWeatherDays() {
    const currentDate = new Date();
    const weatherDate = new Date(this.state.weatherDates);
    const diffTime = Math.abs(weatherDate.getTime() - currentDate.getTime());
    const weatherDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    await this.props.setWeatherDays(weatherDays);
  }

  render() {
    const keysOfGroupedStatistics = Object.keys(this.props.statisticsGrouped);

    return (
      <Drawer
        anchor={'right'}
        open={true}
        variant={'persistent'}
        PaperProps={{
          style: {
            backgroundColor: '#f5f5f5',
          },
        }}
      >
        <IconButton style={{ alignSelf: 'flex-end' }} onClick={this.props.onClose} size="large">
          <CloseIcon fontSize="small" />
        </IconButton>
        <div style={{ width: 250, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant={'body1'}>
            <b>Num Fields Selected:</b> {this.props.totalFields}
          </Typography>
          <br />
          <Typography variant={'body1'}>
            <b>Total Boundary Acres:</b> {this.props.totalAcres}
          </Typography>
          <Typography variant={'body1'}>
            <b>Total Ops. Acres:</b> {this.props.totalOpsAcres}
          </Typography>
          <br />
          <Typography variant={'body1'}>
            <b>Total Samples:</b> {this.props.totalSamples}
          </Typography>
          <br />
          <Divider style={{ width: '100%' }} />
          <br />
          <Typography variant={'body1'}>
            <b>Avg Acres Per Field:</b> {this.props.averageAcres}
          </Typography>
          <br />
          <Typography variant={'body1'}>
            <b>Avg Samples Per Field:</b> {this.props.averageSamples}
          </Typography>
          <br />
          <Divider style={{ width: '100%' }} />
          <br />

          <FormControl>
            <FormControlLabel
              label="Group Statistics"
              control={
                <Select
                  value={this.state.groupStatisticsBy}
                  onChange={async (event) => {
                    const newValue = event.target.value as GroupStatisticsBy;
                    this.setState({ groupStatisticsBy: newValue });
                    this.props.onGroupStatisticsByChange(newValue);
                  }}
                  style={{ marginLeft: 25, marginRight: 25, width: '25%' }}
                  autoWidth
                >
                  {groupStatisticsByOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
          </FormControl>

          <br />

          {keysOfGroupedStatistics.length > 0 &&
            keysOfGroupedStatistics.map((groupByKey: string) => (
              <Grid container key={groupByKey} spacing={2} style={{ padding: 10 }} size={12}>
                <Divider style={{ width: '100%' }} />

                <Typography variant={'body1'}>
                  <b>{groupByKey}</b>
                </Typography>

                <Grid size={12}>
                  <Typography variant={'body1'}>
                    Num Fields: {this.props.statisticsGrouped[groupByKey].totalFields}
                  </Typography>
                </Grid>

                <Grid size={12}>
                  <Typography variant={'body1'}>
                    Total Acres: {Math.round(this.props.statisticsGrouped[groupByKey].totalAcres)}
                  </Typography>
                </Grid>

                <Grid size={12}>
                  <Typography variant={'body1'}>
                    Total Samples: {Math.round(this.props.statisticsGrouped[groupByKey].totalSamples)}
                  </Typography>
                </Grid>

                <Grid size={12}>
                  <Typography variant={'body1'}>
                    Avg Acres Per Field:{' '}
                    {this.props.statisticsGrouped[groupByKey].fieldsWithValidAcresNumber > 0
                      ? Math.round(
                          this.props.statisticsGrouped[groupByKey].totalAcres /
                            this.props.statisticsGrouped[groupByKey].fieldsWithValidAcresNumber,
                        )
                      : ''}
                  </Typography>
                </Grid>

                <Grid size={12}>
                  <Typography variant={'body1'}>
                    Avg Samples Per Field:{' '}
                    {this.props.statisticsGrouped[groupByKey].fieldsWithValidSamplesNumber > 0
                      ? Math.round(
                          this.props.statisticsGrouped[groupByKey].totalSamples /
                            this.props.statisticsGrouped[groupByKey].fieldsWithValidSamplesNumber,
                        )
                      : ''}
                  </Typography>
                </Grid>
              </Grid>
            ))}

          <br />
          <Divider style={{ width: '100%' }} />
          <br />

          <Typography variant={'body1'}>Set Weather Date</Typography>

          <br />

          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <TextField
              variant={'standard'}
              type={'date'}
              value={this.state.weatherDates}
              onChange={(e) => this.setState({ weatherDates: e.target.value })}
              color={'secondary'}
            />
            <LoadingButton
              style={{ textTransform: 'capitalize' }}
              onClick={this.setWeatherDays}
              disabled={!this.state.weatherDates}
            >
              Set
            </LoadingButton>
          </div>
          <br />
          <Divider style={{ width: '100%' }} />
          <br />
          <Typography variant={'body1'}>Job Links</Typography>
          <br />
        </div>
        <div style={{ marginLeft: 20, flexDirection: 'column', display: 'flex', paddingBottom: 10 }}>
          {this.props.jobLinks.map((jobLink) => (
            <Typography key={jobLink.name} variant={'caption'}>
              <a href={jobLink.link}>{jobLink.name}</a>
            </Typography>
          ))}
        </div>
      </Drawer>
    );
  }
}
